module.exports = __webpack_public_path__ + "img/lagerausbildung-2bohrungen_zzz.55fd9e31.jpg";